"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, ms);
    });
}
exports.sleep = sleep;
exports.wait = sleep;
function withTime(label, fn) {
    console.time(label);
    var r = fn();
    console.timeEnd(label);
    return r;
}
exports.withTime = withTime;
//# sourceMappingURL=sleep.js.map